var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',{attrs:{"id":"app"}},[_c('v-slide-y-reverse-transition',[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }